var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toasts"},[_c('transition-group',{attrs:{"name":"toast-slide"}},_vm._l((_vm.messages),function(m){return _c('toast',_vm._b({key:m.id,nativeOn:{"click":function($event){return _vm.close(m)}}},'toast',m,false))}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }